module.exports = __webpack_public_path__ + "static/media/icon.bcd9ea3c.png";